<div fxLayout="row" fxLayoutAlign="center" ngClass.lt-lg="p-t-m">
	<div
		fxLayout="column"
		fxFlex.gt-md="85%"
		fxFlex.md="95%"
		fxFlex.sm="100%"
		fxLayoutAlign="center center"
		ngClass.gt-sm="p-xxl"
		ngClass.sm="p-l p-t-xxl"
		ngClass.xs="p-xl p-t-xxl">
		<div fxLayout="row" fxLayoutAlign="center" ngClass="p-b-xl">
			<h2
				class="dark-grey-texts"
				i18n="@@homepage_start_fundraising_for_startFundraisingFor">
				Start fundraising for
			</h2>
		</div>
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column"
			fxLayoutAlign="center"
			ngClass.xs="p-l-xl p-r-xl"
			fxLayoutGap.gt-xs="2%"
			fxLayoutGap.xs="5%">
			<mat-card
				class="mat-elevation-z2 hover-on-card"
				fxFlex.gt-xs="33%">
				<mat-card-content class="grey-bg" fxFlex="100%">
					<div
						fxLayout="column"
						fxLayoutGap="5%"
						fxLayoutAlign="center center"
						ngClass="p-l-m p-r-m p-t-s">
						<div fxLayout="row" ngClass="p-b-xs">
							<img
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/yourself/public" />
						</div>
						<div fxLayout="row">
							<mat-card-title
								class="dark-grey-texts"
								i18n="@@homepage_start_fundraising_for_yourself">Yourself</mat-card-title>
						</div>
						<div fxLayout="row">
							<span
								class="mat-subtitle-2 dark-grey-texts text-align-center"
								i18n="@@homepage_start_fundraising_for_yourselfContent">Donations are
								paid directly to you so you can use them for the
								purpose.
							</span>
						</div>
						<div fxLayout="row" class="bottom-sticky" fxHide.lt-sm>
							<div class="white-bg">
								<app-start-fundraiser-button
									buttonType="stroked"
									themeColor="accent"></app-start-fundraiser-button>
							</div>
						</div>
						<div fxLayout="row" fxHide.gt-xs>
							<div class="white-bg" ngClass="m-t-m">
								<app-start-fundraiser-button
									buttonType="stroked"
									themeColor="accent"></app-start-fundraiser-button>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			<mat-card
				class="mat-elevation-z2 hover-on-card"
				fxFlex.gt-xs="33%">
				<mat-card-content class="grey-bg">
					<div
						fxLayout="column"
						fxLayoutGap="5%"
						fxLayoutAlign="center center"
						ngClass="p-l-m p-r-m p-t-s">
						<div fxLayout="row" ngClass="p-b-xs">
							<img
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/someoneElse/public" />
						</div>
						<div fxLayout="row">
							<mat-card-title
								class="dark-grey-texts text-align-center nowrap"
								i18n="@@homepage_start_fundraising_for_someoneElse">Someone Else</mat-card-title>
						</div>
						<div fxLayout="row">
							<span
								class="mat-subtitle-2 dark-grey-texts text-align-center"
								i18n="@@homepage_start_fundraising_for_someoneElseContent">Start a
								fundraiser for someone else and have the donations
								disbursed directly to them, or distribute them yourself.
							</span>
						</div>
						<div fxLayout="row" ngClass="p-t-xs">
							<div class="white-bg">
								<app-start-fundraiser-button
									buttonType="stroked"
									themeColor="accent"></app-start-fundraiser-button>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			<mat-card
				class="mat-elevation-z2 hover-on-card"
				fxFlex.gt-xs="33%">
				<mat-card-content class="grey-bg" fxFlex="100%">
					<div
						fxLayout="column"
						fxLayoutGap="5%"
						fxLayoutAlign="center center"
						ngClass="p-l-m p-r-m p-t-s">
						<div fxLayout="row">
							<img
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/charity/public" />
						</div>
						<div fxLayout="row">
							<mat-card-title
								class="dark-grey-texts"
								i18n="@@homepage_start_fundraising_for_charity">Charity</mat-card-title>
						</div>
						<div fxLayout="row">
							<span
								class="mat-subtitle-2 dark-grey-texts text-align-center"
								i18n="@@homepage_start_fundraising_for_charityContent">Start a
								fundraiser
								for charity or individual and raise money to
								achieve your goals.
							</span>
						</div>
						<div fxLayout="row" class="bottom-sticky" fxHide.lt-sm>
							<div class="white-bg">
								<app-start-fundraiser-button
									buttonType="stroked"
									themeColor="accent"></app-start-fundraiser-button>
							</div>
						</div>
						<div fxLayout="row" fxHide.gt-xs>
							<div class="white-bg" ngClass="m-t-m">
								<app-start-fundraiser-button
									buttonType="stroked"
									themeColor="accent"></app-start-fundraiser-button>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>
